import { render, staticRenderFns } from "./about.vue?vue&type=template&id=a8fcf624&scoped=true&"
var script = {}
import style0 from "./about.vue?vue&type=style&index=0&id=a8fcf624&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fcf624",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8fcf624')) {
      api.createRecord('a8fcf624', component.options)
    } else {
      api.reload('a8fcf624', component.options)
    }
    module.hot.accept("./about.vue?vue&type=template&id=a8fcf624&scoped=true&", function () {
      api.rerender('a8fcf624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/my/about.vue"
export default component.exports